<div class="info">
  <div class="overview">
    <div class="title">
      <inline-svg [src]="getProjectIconPath(project)" class="folder-icon" color="#85BBF3"></inline-svg>
      <span> {{ project?.name }}</span>
      <div class="spacer"></div>
      <inline-svg src="edit.svg" class="folder-icon"
        (click)="editProject()"
        color="#A5B5BDFF"
      hoverColor="#7F8F98"></inline-svg>
    </div>
    <div class="detail">
      <div>Created</div>
      <div>{{project.created_at | date: "dd/M/yyyy" }}</div>
    </div>
    <div class="detail">
      <div>Created by</div>
      <div>{{ project?.user?.email }}</div>
    </div>
    <div class="detail">
      <div>Description</div>
      <div>{{ project?.description }}</div>
    </div>
  </div>
  <div class="metrics">
    <div class="metric-card">
      <span>{{ project?.downloads_count }}</span>
      <span>Downloads</span>
    </div>
    <div class="metric-card">
      <span>{{ project?.uploads_count }}</span>
      <span>Import files</span>
    </div>
    <div class="metric-card">
      <span>{{ project.reports_count }}</span>
      <span>Reports</span>
    </div>
    <div class="metric-card">
      <span>{{project.geometry_stats.total_count}}</span>
      <span>AOIs</span>
    </div>
  </div>
</div>
<div class="files">
  <div class="navigation">
    <div [ngClass]="{'active': currentFiles == 'all'}" (click)="changeFileType('all')">All Files</div>
    <div [ngClass]="{'active': currentFiles == 'report'}" (click)="changeFileType('report')">Exposure Reports
    </div>
    <div [ngClass]="{'active': currentFiles == 'upload'}" (click)="changeFileType('upload')">Import Files</div>
    <div [ngClass]="{'active': currentFiles == 'download'}" (click)="changeFileType('download')">Downloads</div>
  </div>
  <div class="table">
    <div class="table-controls">
      <span class="title">My Files </span>
      <div class="spacer"></div>
      <mat-form-field appearance="outline" class="search-field">
        <inline-svg src="search.svg" matPrefix></inline-svg>
        <input matInput [formControl]="fileSearchCtrl" placeholder="Search by file name">
        @if (fileSearchCtrl.value.length) {
          <div matSuffix class="search-suffix" (click)="$event.stopPropagation()"
            >
            <inline-svg src="small_close.svg" (click)="clearSearch()"></inline-svg>
          </div>
        }
      </mat-form-field>
      <div class="filter-icon">
        <inline-svg src="Filter.svg" matTooltip="Filters"
          color="#A5B5BD"
          hoverColor="#7F8F98"
          [matMenuTriggerFor]="filter" [ngClass]="{'active': filterTrigger.menuOpen}"
          #filterTrigger="matMenuTrigger">
        </inline-svg>
        <mat-menu #filter="matMenu" yPosition="above" xPosition="after" class="uploadBox" hasBackdrop="false">
          <frmg-file-filter (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
            (closeMenu)="closeFilter()" (onApply)="onApplyFilter($event)"
            [filter]="fileFilter"/>
          </mat-menu>
          @if (getAppliedFilter()) {
            <div class="counter">
              <span>{{ appliedFilterCount }}</span>
            </div>
          }
        </div>
      </div>
      <div class="pseudo-table">
        <div class="header">
          <div class="column-name">Name</div>
          <div class="column-date">Date</div>
          <div class="column-user">Owner</div>
          <div class="column-type">File Type</div>
          <div class="column-action"></div>
        </div>
        <div class="horizontal-separator"></div>
        <div class="body">
          @for (file of files; track file) {
            <div class="row">
              <div class="column-name">
                <div class="type">
                  <inline-svg [src]="getProjectIconPath(project)" class="folder-icon" color="#85BBF3"></inline-svg>
                </div>
                <span>{{ file.details.name }}</span>
              </div>
              <div class="column-date">
                <span>{{ file.created_at | date: "dd/MM/yyyy" }}</span>
              </div>
              <div class="column-user">
                <span>{{ file.user.email  === this.currentUser.email ? "Me" : file.user.email }}</span>
              </div>
              <div class="column-type">
                <span>{{ file.format }}</span>
              </div>
              <div class="column-action">
                <inline-svg src="Hamburger_menu.svg" class="menu-icon" color="#A5B5BD"
                  hoverColor="#7F8F98"
                  [matMenuTriggerFor]="projectMenu"
                  #menuOpen='matMenuTrigger'
                (click)="toggleMenu(file, $event)"></inline-svg>
                <mat-menu #projectMenu="matMenu" xPosition="before"
                  (closed)="toggleMenu(null)">
                  <button mat-menu-item (click)="downloadFile(file)" class="menu-slot">
                    Download
                  </button>
                </mat-menu>
              </div>
            </div>
          }

          @if (files.length === 0) {
            <div class="empty-state">
              <div class="empty-state-content">
                <inline-svg src="info-chat.svg" class="empty-icon" color="#A5B5BD"></inline-svg>
                <h3>No results found</h3>
                <p>Please try adjusting search or filter to find what you're looking for.</p>
              </div>
            </div>
          }
        </div>
        <div class="horizontal-separator"></div>
      </div>
    </div>
  </div>